import React from 'react'
import PropTypes from 'prop-types'

DataTableBody.propTypes = {
    error: PropTypes.string,
    statics: PropTypes.array
}

function DataTableBody(props) {
    const {error, statics} = props

    return (
        <tbody className='DataTableBody'>
        {
            !!statics && statics.length > 0 && statics.map(item =>
                <tr key={item.sku}>
                    <td>{item.sku || ''}</td>
                    <td className='text-center'>{item.total || 0}</td>
                    <td className='text-center'>{item.pending || 0}</td>
                    {/* <td className='text-center'>{item.printing || 0}</td> */}
                    <td className='text-center'>{item.printed || 0}</td>
                    <td className='text-center'>{item.cut || 0}</td>
                    <td className='text-center'>{item.engraved || 0}</td>
                    <td className='text-center'>{item.improved || 0}</td>
                    {/* <td className='text-center'>{item.wait_to_sew || 0}</td>
                    <td className='text-center'>{item.sewing || 0}</td> */}
                    <td className='text-center'>{item.completed || 0}</td>
                </tr>
            )
        }

        {
            !!error && error.length > 0 && <tr>
                <td colSpan={8} className='text-danger'>{error}</td>
            </tr>
        }

        {
            statics.length === 0 && <tr>
                <td colSpan={8}>No data</td>
            </tr>
        }
        </tbody>
    )
}

export default DataTableBody
